import { Box, IconButton, InputBase } from "@mui/material";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import Shbutton from "../../../../theme/buttons/Shbutton";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Text from "../../../../theme/text/Text";
import Dropdown from "../../../../theme/dropout/DropOut";
import { useEffect, useState } from "react";
import ButtonGroup from "../../../../theme/buttons/ButtonGroup";
import {  useDeleteRelationMutation, useEditRelationMutation } from "../../../../../newapi/global/relation/relationSlice";
import { useGetInvoiceCategorySelectQuery } from "../../../../../newapi/financial/invoiceCategorySlice";
import ShSwitch from "../../../../theme/inputs/ShSwitch";
import dayjs from 'dayjs';

import { useTranslation } from "react-i18next";
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import { showToastMessage, showToastMessageDeleteRequest, showToastMessageRequestError, showToastMessageUpdateRequest} from "../../../../../utils/toasts";
import MConfirmation from '../../../Modals/MConfirmation';
import SpDesktopFooter from "../../../../theme/sidepanel2/SidepanelFooter";
import * as yup from "yup";
import ShValidatedInput from "../../../../theme/inputs/ShValidatedInput";
import { yupRequired } from "../../../../../utils/validation";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import EMGeneralExplainerBox from "../../../ModalsPopover/explainers/EMGeneralExplainerBox";
import { useGetAccountingSoftwareTaxRatesSelectQuery } from "../../../../../newapi/financial/accountingSoftwareSlice";
import { countriesFromLocale } from '../../../../../utils/countries';
import { countryCodeNL } from '../../../../../utils/constants';
import { useGetWarehousesSelectQuery, useGetWarehouseZonesSelectQuery } from "../../../../../newapi/warehouse/warehouseApiSlice";
import { useGetEnumsQuery, useGetSettingsQuery } from "../../../../../newapi/global/generalApiSlice";
import NumberInput from "../../../../theme/inputs/NumberInput";
import { useGetShippersSelectQuery } from "../../../../../newapi/shipper/shipperSlice";
import ShTimePicker from "../../../../theme/ShTimePicker";
import { echeck_confirm_product_amount_option, echeck_scan_option } from "../../../../../utils/staticEnums";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import cx from "classnames"
import { useGetWebshopCredentialsSelectQuery } from '../../../../../newapi/webshop/webshopSlice';

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <ButtonGroup version={2}>
            {props.hasModifyPrivilege && (
            <Shbutton
                isLoading={props.isLoading}
                className={"group-btn"}
                onClick={props.action}
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                variant="contained"
                endIcon={<SaveIcon />}
            >
                {t('save')}
            </Shbutton>
            )}
        </ButtonGroup>
    );
};

const DetailsPanel = (props) => {
    const  { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RELATION_MANAGE])
    );

    const {data: dropshippingEnabled, isLoading: isLoadingSettings} = useGetSettingsQuery("dropshipping_enabled");
    const { data: trackAndTraceSettings } = useGetSettingsQuery("allow_track_and_trace_mails");
    const showTrackAndTraceMails = trackAndTraceSettings?.find(s => s.key === "allow_track_and_trace_mails")?.value === "true";
    
    const [showDropshipping, setShowDropshipping] = useState(false);
    useEffect(() => {
        if (dropshippingEnabled) {
            setShowDropshipping(dropshippingEnabled?.find(setting => setting.key === "dropshipping_enabled")?.value === "true");
        }
    }, dropshippingEnabled);

    const language = useSelector((state) => state.settings.language);
    const countries = countriesFromLocale(language);
    const [fieldErrors, setFieldErrors] = useState({});
    const rules = {
        name: yupRequired('name', t),
    };
    const schema = yup.object().shape(rules);

    const [invoiceCategoryModified, setInvoiceCategoryModified] = useState(false);

    const [relationInfo, setRelationInfo] = useState({
      id: 0,
      name: "",
      phone: "",
      email: "",
      website: "",
      street: "",
      house_nr: "",
      house_nr_extra: "",
      postal: "",
      city: "",
      kvk: "",
      vatNumber: "",
      eoriNumber: "",
      debtorNumber: "",
      invoiceCategoryId: 0,
      invoiceEmail: "",
      autoAddPickingSlip: false,
      pickingslipPerCarrier: false,
      warehouseId: null,
      invoicingFrequency: "",
      invoiceReference: "",
      shippingName: "",
      warehouseZoneId: null,
      cutoffTime: "",
      fuelSurchargeAdjustmentPerShipper: [],
      echeckProductValidation: "",
      echeckAlwaysPrintBulkLabels: false,
      echeckConfirmProductAmount: "",
      echeckOrderValueThreshold: null
    });

    const [open, setOpen] = useState(false);

    const { data: globalEnums, enumIsLoading } = useGetEnumsQuery("invoicing_frequency");
    const [invoicingFrequencies, setInvoicingFrequencies] = useState([]);
    const echeckProductValidationOptions = [
        {
            id: echeck_scan_option.DEFAULT, name: t("default"), displayName: t("default")
        },
        {
            id: echeck_scan_option.ALWAYS_SCAN, name: t("always_scan"), displayName: t("always_scan")
        },
        {
            id: echeck_scan_option.NEVER_SCAN, name: t("never_scan"), displayName: t("never_scan")
        }
    ];
    // Default follows the general setting echeck_confirm_product_amount
    const echeckConfirmProductAmountOptions = [
        {
            id: echeck_confirm_product_amount_option.DEFAULT, name: t("default"), displayName: t("default")
        },
        {
            id: echeck_confirm_product_amount_option.ALWAYS, name: t("always_confirm"), displayName: t("always_confirm")
        },
        {
            id: echeck_confirm_product_amount_option.NEVER, name: t("never_confirm"), displayName: t("never_confirm")
        }
    ];

    useEffect(() => {
        setInvoicingFrequencies(globalEnums ? globalEnums["invoicing.frequency"] : []);
    },[globalEnums]);
    
    const { data: invoiceCategories, invoiceCategoryIsLoading } = useGetInvoiceCategorySelectQuery();
    const { data: taxRates, taxRatesIsLoading } = useGetAccountingSoftwareTaxRatesSelectQuery();
    const { data: warehouses, warehousesIsLoading } = useGetWarehousesSelectQuery();
    const { data: warehouseZones, warehouseZonesIsLoading } = useGetWarehouseZonesSelectQuery();
    const { data: shippers, shippersIsLoading } = useGetShippersSelectQuery();
    const [ warehouseOptions, setWarehouseOptions ] = useState([]);
    const [ warehouseZoneOptions, setWarehouseZoneOptions ] = useState([]);
    const [ shipperOptions, setShipperOptions ] = useState([]);

    const [taxRateOptions, setTaxRateOptions] = useState([]);

    useEffect(() => {
        if (taxRates && taxRates.length > 0) {
            setTaxRateOptions([{id: null, description: t('none')}, ...taxRates]);
        }
    },[taxRates]);

    useEffect(() => {
        if (warehouses && warehouses.success) {
            const options = [{id: null, name: t('none')}, ...warehouses.data];
            setWarehouseOptions(options);
        }
    },[warehouses]);

    useEffect(() => {
        if (warehouseZones?.data && relationInfo && warehouseZoneOptions.length === 0) {
            const filteredZones = warehouseZones.data
            .filter(x => !relationInfo.warehouseId || relationInfo.warehouseId === x.warehouse.id)
            .map(x => { return {id: x.id, name: x.description}});

            const options = [{id: null, name: t('none')}, ...filteredZones];
            setWarehouseZoneOptions(options);
        }
    },[warehouseZones, relationInfo]);

    useEffect(() => {
        if (shippers) {
            setShipperOptions(shippers);
        }
    },[shippers]);

    const { data: webshopCredentials } = useGetWebshopCredentialsSelectQuery(relationInfo?.id,
        {
            skip: !relationInfo?.id
        }
    );

    const [credentialOptions, setCredentialOptions] = useState([]);

    useEffect(() => {
        if (webshopCredentials) {
            setCredentialOptions(webshopCredentials.map(x => { return {id: x.id, name: `${x.description} (${x.webshop_type})`}}));
        }
    }, [webshopCredentials]);

    const [EditRelation,{isLoading}] = useEditRelationMutation();
    const handleSaveClick = async (event,fromConfirmModal = false, updateCurrentInvoice = false) => {
        try {
            if(isLoading) return;

            if (!fromConfirmModal && invoiceCategoryModified) {
                setConfirmModalOpen(true);
                return;
            }

            const mappedFuelSurchargeAdjustmentPerShipper = relationInfo.fuelSurchargeAdjustmentPerShipper?.filter(x => x.shipperId > 0) ?? null;

            setFieldErrors({});

            const updateObj = {
                ...relationInfo,
                ...(mappedFuelSurchargeAdjustmentPerShipper ? {fuelSurchargeAdjustmentPerShipper: mappedFuelSurchargeAdjustmentPerShipper} : {}),
                updateCurrentInvoice
            }

            await schema.validate(updateObj, { abortEarly: false });
            const response = await EditRelation(updateObj).unwrap();
            showToastMessageUpdateRequest(t, response);
            setInvoiceCategoryModified(false);
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                    ...acc,
                    [currentError.path]: currentError.message
                }), {});
            
                // Set the validation errors in the state
                setFieldErrors(errors);
            } else {
                showToastMessageRequestError(t("update_failed"), t, err);
            }
        }
    };
    
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const confirmModal = {
        open: confirmModalOpen,
        setOpen: setConfirmModalOpen,
    };

    const handleConfirmConfirm = () => {
        setConfirmModalOpen(false);
        handleSaveClick(null, true, true);
    };

    const handleConfirmClose = () => {
        confirmModal.setOpen(false);
        handleSaveClick(null, true, false);
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            mobileActions: <GridActions 
                isLoading={isLoading}
                id={relationInfo?.id}
                action={handleSaveClick}
                hasModifyPrivilege={hasModifyPrivilege}
            />,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[handleSaveClick,relationInfo]);

    

    useEffect(() => {
        setRelationInfo(props.data);
    },[props.data]);

    const handleChange = (key, value) => {
        if (key === "cutoffTime") {
            // A cleared picker gives an invalid time, which removes the cutoff
            value = value && dayjs(value).isValid() ? dayjs(value).format("HH:mm") : null;
        }

        if (key === "invoiceCategoryId") {
            setInvoiceCategoryModified(true);
        }

        setRelationInfo({
          ...relationInfo,
          [key]: value
        });
      };

    const handleShipperAdjustmentChange = (index, field, value) => {
        // Check if shipper is already selected in another row
        if (field === 'shipperId') {
            const adjustments = relationInfo.fuelSurchargeAdjustmentPerShipper || [];
            const isAlreadySelected = adjustments.some((item, i) => i !== index && item.shipperId === value);

            if (isAlreadySelected) {
                showToastMessage("error", t("shipper_already_selected"));
                value = -1;
            }
        }

        setRelationInfo(prevInfo => ({
            ...prevInfo,
            fuelSurchargeAdjustmentPerShipper: (prevInfo.fuelSurchargeAdjustmentPerShipper || []).map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        }));
    };

    const handleDeleteShipperAdjustment = (index) => {
        setRelationInfo(prevInfo => ({
            ...prevInfo,
            fuelSurchargeAdjustmentPerShipper: (prevInfo.fuelSurchargeAdjustmentPerShipper || []).filter((_, i) => i !== index)
        }));
    };

    const handleNewShipperAdjustmentRow = () => {
        setRelationInfo(prevInfo => ({
            ...prevInfo,
            fuelSurchargeAdjustmentPerShipper: [...(prevInfo.fuelSurchargeAdjustmentPerShipper || []), { shipperId: null, surchargeAdjustment: 0 }]
        }));
    };

    const handleDeleteClick = async () => {
        setOpen(true);
    };

    const commonLabelWidth = 180;
    const shippingLabelWidth = showTrackAndTraceMails ? 320 : 256;

    return (
        <Box height={1} display={"flex"} flexDirection={"column"} paddingX={3}
            sx={{
                "@media screen and (min-width: 48.1em)"  :{
                    marginBottom:11
                }
            }}
        >
        <Dropdown title={t("contact")} subTitle={t("sp_relation_contact_subtitle")} open>
            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                "@media screen and (max-width: 47.9375em)" : {
                    flexDirection:"column"
                }
            }}>
                
                {/* Two columns */}
                
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 1.5,
                        justifyContent:"flex-start",
                        flexDirection:"column"
                    }}
                >
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("name")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="name"
                            value={relationInfo?.name}
                            onChange={handleChange}
                            error={fieldErrors.name}
                        />
                    </Box>
                </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("phone")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="phone"
                                value={relationInfo?.phone}
                                onChange={handleChange}
                                error={fieldErrors.phone}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("email")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="email"
                                value={relationInfo?.email}
                                onChange={handleChange}
                                error={fieldErrors.email}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("website")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="website"
                                value={relationInfo?.website}
                                onChange={handleChange}
                                error={fieldErrors.website}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Dropdown>
        <Dropdown title={t("address_details")} subTitle={t("sp_relation_address_subtitle")} open>
            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                "@media screen and (max-width: 47.9375em)" : {
                    flexDirection:"column"
                }
            }}>
                
                {/* Two columns */}
                
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 1.5,
                        justifyContent:"flex-start",
                        flexDirection:"column"
                    }}
                >
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("street")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="street"
                            value={relationInfo?.street}
                            onChange={handleChange}
                            error={fieldErrors.street}
                        />
                    </Box>
                </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("house_nr")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="house_nr"
                                value={relationInfo?.house_nr}
                                onChange={handleChange}
                                error={fieldErrors.house_nr}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("house_nr_extra")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="house_nr_extra"
                                value={relationInfo?.house_nr_extra}
                                onChange={handleChange}
                                error={fieldErrors.house_nr_extra}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("postal")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="postal"
                                value={relationInfo?.postal}
                                onChange={handleChange}
                                error={fieldErrors.postal}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("city")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="city"
                                value={relationInfo?.city}
                                onChange={handleChange}
                                error={fieldErrors.city}
                            />
                        </Box>
                    </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("country")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        searchOptions={{
                            enabled: true,
                            placeholder: t("search")
                        }}
                        styles={{
                            minWidth:300
                        }}
                        name="country"
                        displayName="name"
                        selected={countries?.findIndex(country => country.alpha2 === (relationInfo?.country || countryCodeNL)) ?? -1}
                        options={countries ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleChange('country', countries[selected]?.alpha2)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                </Box>
            </Box>
        </Dropdown>
        <Dropdown title={t("other_details")} subTitle={t("sp_relation_other_subtitle")}>
            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                "@media screen and (max-width: 47.9375em)" : {
                    flexDirection:"column"
                }
            }}>
                
                {/* Two columns */}
                
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 1.5,
                        justifyContent:"flex-start",
                        flexDirection:"column"
                    }}
                >
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("coc_number")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="kvk"
                            value={relationInfo?.kvk}
                            onChange={handleChange}
                            error={fieldErrors.kvk}
                        />
                    </Box>
                </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("vat_number")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="vatNumber"
                                value={relationInfo?.vatNumber}
                                onChange={handleChange}
                                error={fieldErrors.vatNumber}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("eori_number")}</Text>
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="eoriNumber"
                                value={relationInfo?.eoriNumber}
                                onChange={handleChange}
                                error={fieldErrors.eoriNumber}
                            />
                        </Box>
                    </Box>
                    {warehouseOptions.length > 2 && (
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("warehouse")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        name="warehouseId"
                        displayName="name"
                        selected={warehouseOptions ? warehouseOptions.findIndex(item => item.id === relationInfo?.warehouseId) ?? -1 : -1}
                        options={warehouseOptions ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleChange('warehouseId', warehouseOptions[selected]?.id)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                )}
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("warehouse_zone")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        name="warehouseZoneId"
                        displayName="name"
                        selected={warehouseZoneOptions ? warehouseZoneOptions.findIndex(item => item.id === relationInfo?.warehouseZoneId) ?? -1 : -1}
                        options={warehouseZoneOptions ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleChange('warehouseZoneId', warehouseZoneOptions[selected]?.id)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                </Box>
            </Box>
        </Dropdown>
        <Dropdown title={t("financial")} subTitle={t("sp_relation_financial_subtitle")}>
            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                "@media screen and (max-width: 47.9375em)" : {
                    flexDirection:"column"
                }
            }}>
                
                {/* Two columns */}
                
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 1.5,
                        justifyContent:"flex-start",
                        flexDirection:"column"
                    }}
                >
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("debtor_number")}</Text>
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="debtorNumber"
                            value={relationInfo?.debtorNumber}
                            onChange={handleChange}
                            error={fieldErrors.debtorNumber}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("invoice_name")}</Text>
                        <EMGeneralExplainerBox
                            title={t("invoice_name")}
                            text={t("invoice_name_explainer")}
                        />
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="invoiceName"
                            value={relationInfo?.invoiceName}
                            onChange={handleChange}
                            error={fieldErrors.invoiceName}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("invoice_email")}</Text>
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="invoiceEmail"
                            value={relationInfo?.invoiceEmail}
                            onChange={handleChange}
                            error={fieldErrors.invoiceEmail}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("invoice_reference")}</Text>
                        <EMGeneralExplainerBox
                            title={t("invoice_reference")}
                            text={t("invoice_reference_explainer")}
                        />
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="invoiceReference"
                            value={relationInfo?.invoiceReference}
                            onChange={handleChange}
                            error={fieldErrors.invoiceReference}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("invoice_category")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        name="name"
                        displayName="name"
                        selected={invoiceCategories ? invoiceCategories.findIndex(item => item.id === relationInfo?.invoiceCategory?.id) ?? -1 : -1}
                        options={invoiceCategories ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleChange('invoiceCategoryId', invoiceCategories[selected]?.id)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("tax_rate")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        name="taxRateId"
                        displayName="description"
                        selected={taxRateOptions ? taxRateOptions.findIndex(item => item.id === relationInfo?.taxRateId) ?? -1 : -1}
                        options={taxRateOptions ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleChange('taxRateId', taxRateOptions[selected]?.id)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box 
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("invoicing_frequency")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <InputDropdown
                            name="invoicingFrequency"
                            displayName="displayName"
                            changeField="name"
                            valueKey="id"
                            selected={invoicingFrequencies.findIndex(item => item === relationInfo?.invoicingFrequency) ?? -1}
                            options={invoicingFrequencies.map((item, index) => ({ id: index, name: item, displayName: t(`${item}`) }))}
                            noSelection={t("choose_option")} 
                            onChange={(selected) => handleChange('invoicingFrequency', invoicingFrequencies[selected])}
                            closeOnSelection
                        />
                    </Box>
                </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:commonLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("monthly_closing")}</Text>
                            <EMGeneralExplainerBox
                                title={t("em_relation_monthly_closing_title")}
                                text={t("em_relation_monthly_closing_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch 
                            checked={relationInfo?.hasMonthlyClosing} 
                            onChange={(event) => handleChange('hasMonthlyClosing', event.target.checked)} 
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Dropdown>
        <Dropdown title={t("fuel_surcharges")} subTitle={t("sp_relation_fuel_surcharges_subtitle")}>
            <Box sx={{
                display:"flex",
                flexDirection:"column",
                gap: 1.5,
            }}>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("fuel_surcharge_adjustment")}</Text>
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <NumberInput
                            btnSize={"24"}
                            value={relationInfo?.fuelSurchargeAdjustment}
                            change={(newValue) => handleChange("fuelSurchargeAdjustment", newValue)}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", marginTop: 2 }}>
                    <Text semibold>{t("fuel_surcharge_adjustment_shippers")}</Text>
                        <EMGeneralExplainerBox
                            title={t("fuel_surcharge_adjustment_shippers")}
                            text={t("em_fuel_surcharge_adjustment_shippers_text")}
                        />
                </Box>

                {relationInfo?.fuelSurchargeAdjustmentPerShipper?.length > 0 && relationInfo.fuelSurchargeAdjustmentPerShipper.map((adjustment, index) => (
                    <Box
                        key={"fuel-surcharge-shipper-"+index}
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:1,
                            "@media screen and (max-width:47.9375em)" : {
                                width:1,
                                justifyContent:"space-between",
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width:commonLabelWidth,
                                "@media screen and (max-width:63.9375em)" : {
                                    width:130,
                                }
                            }}
                        >
                            <Text light>{index === 0 ? t("shipper") : ""}</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                                justifyContent:"space-between",
                            }}
                        >
                            <Box sx={{
                                    flex:1,
                                    display:"flex",
                                    alignItems:"center",
                                    height:`40px`,
                                }}
                            >
                                <Box sx={{
                                    flex: 1,
                                    backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                                    borderRadius:32/8,
                                    }}>
                                    <InputDropdown
                                        key={`shipper-dropdown-${index}-${adjustment.shipperId}`}
                                        displayName={"name"}
                                        changeField="id"
                                        valueKey="id"
                                        closeOnSelection
                                        selected={shipperOptions?.findIndex(item => item.id === adjustment.shipperId) ?? -1}
                                        options={shipperOptions ?? []}
                                        noSelection={t("choose_option")}
                                        onChange={(selected) => handleShipperAdjustmentChange(index, 'shipperId', shipperOptions[selected]?.id ?? null)}
                                    />
                                </Box>
                                <Box sx={{ width: 150, 
                                    marginLeft: 1,
                                    backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                                    borderRadius:32/8,  
                                    }}>
                                    <NumberInput
                                        btnSize={"24"}
                                        value={adjustment.surchargeAdjustment ?? 0}
                                        change={(newValue) => handleShipperAdjustmentChange(index, 'surchargeAdjustment', newValue)}
                                    />
                                </Box>
                                <IconButton type="button" onClick={() => handleDeleteShipperAdjustment(index)}
                                sx={{
                                    color: colors.txt["primary"]
                                }}>
                                    <DeleteIcon/>
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>
                ))}
                <Box sx={{marginLeft: 1}}>
                    <ButtonGroup version={2} >
                        <Shbutton className={"group-btn"} color={"green"}
                        variant="contained"
                        startIcon={<AddIcon/>}
                        onClick={() => handleNewShipperAdjustmentRow()}
                        >{t("new")}</Shbutton>
                    </ButtonGroup>
                </Box>
            </Box>
        </Dropdown>
        <Dropdown title={t("scorecard")} subTitle={t("sp_relation_scorecard_subtitle")}>
            <Box sx={{
                display:"flex",
                flexDirection:"column",
                gap: 1.5,
            }}>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("scorecard_factor_pick")}</Text>
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <NumberInput
                            btnSize={"24"}
                            value={relationInfo?.scorePickFactor ?? ""}
                            change={(newValue) => handleChange("scorePickFactor", newValue === "" ? null : newValue)}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("scorecard_factor_order")}</Text>
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <NumberInput
                            btnSize={"24"}
                            value={relationInfo?.scoreOrderFactor ?? ""}
                            change={(newValue) => handleChange("scoreOrderFactor", newValue === "" ? null : newValue)}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("scorecard_factor_return")}</Text>
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <NumberInput
                            btnSize={"24"}
                            value={relationInfo?.scoreReturnFactor ?? ""}
                            change={(newValue) => handleChange("scoreReturnFactor", newValue === "" ? null : newValue)}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        alignItems:"center",
                    }}
                >
                    <Box
                        sx={{
                            width:commonLabelWidth,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text noBreak>{t("scorecard_factor_inbound")}</Text>
                    </Box>
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                        <NumberInput
                            btnSize={"24"}
                            value={relationInfo?.scoreInboundFactor ?? ""}
                            change={(newValue) => handleChange("scoreInboundFactor", newValue === "" ? null : newValue)}
                        />
                    </Box>
                </Box>
            </Box>
        </Dropdown>
        <Dropdown title={t("Sending")} subTitle={t("sp_relation_sending_subtitle")}>
            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                "@media screen and (max-width: 47.9375em)" : {
                    flexDirection:"column"
                }
            }}>
                {/* Two columns */}
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 1.5,
                        justifyContent:"flex-start",
                        flexDirection:"column"
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("auto_add_pickingslip")}</Text>
                            <EMGeneralExplainerBox
                                title={t("em_general_explainer_title")}
                                text={t("em_auto_add_pickingslip_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch
                            checked={relationInfo?.autoAddPickingSlip}
                            onChange={(event) => handleChange('autoAddPickingSlip', event.target.checked)}
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>
                    {relationInfo?.autoAddPickingSlip && (
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("pickingslip_per_carrier")}</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch
                            checked={relationInfo?.pickingslipPerCarrier}
                            onChange={(event) => handleChange('pickingslipPerCarrier', event.target.checked)}
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>
                    )}
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("shipping_name")}</Text>
                            <EMGeneralExplainerBox
                                title={t('shipping_name')}
                                text={t('em_relation_shippingname_text')}
                            />
                        </Box>
                        <Box display="flex"
                            // maxWidth="400px"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="shippingName"
                                value={relationInfo?.shippingName}
                                onChange={handleChange}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("custom_cutoff")}</Text>
                            <EMGeneralExplainerBox
                                title={t("custom_cutoff")}
                                text={t("em_custom_cutoff_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                            <ShTimePicker
                                clearable
                                value={relationInfo?.cutoffTime ? dayjs(relationInfo.cutoffTime, "HH:mm") : null}
                                onChange={(e) => {
                                    handleChange(`cutoffTime`, e)
                                }}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("echeck_product_validation")}</Text>
                            <EMGeneralExplainerBox
                                title={t("echeck_product_validation")}
                                text={t("em_echeck_product_validation_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <InputDropdown
                            key={relationInfo?.echeckProductValidation}
                            name="echeckProductValidation"
                            displayName="displayName"
                            changeField="id"
                            valueKey="id"
                            selected={relationInfo?.echeckProductValidation ?? -1}
                            options={echeckProductValidationOptions}
                            noSelection={t("choose_option")}
                            onChange={(selected) => handleChange('echeckProductValidation', selected)}
                            closeOnSelection
                        />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("echeck_confirm_product_amount_title")}</Text>
                            <EMGeneralExplainerBox
                                title={t("echeck_confirm_product_amount_title")}
                                text={t("em_relation_echeck_confirm_product_amount_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <InputDropdown
                            key={relationInfo?.echeckConfirmProductAmount}
                            name="echeckConfirmProductAmount"
                            displayName="displayName"
                            changeField="id"
                            valueKey="id"
                            selected={relationInfo?.echeckConfirmProductAmount ?? -1}
                            options={echeckConfirmProductAmountOptions}
                            noSelection={t("choose_option")}
                            onChange={(selected) => handleChange('echeckConfirmProductAmount', selected)}
                            closeOnSelection
                        />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("echeck_order_value_threshold_title")}</Text>
                            <EMGeneralExplainerBox
                                title={t("echeck_order_value_threshold_title")}
                                text={t("em_relation_echeck_order_value_threshold_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <NumberInput
                            btnSize={"24"}
                            onlyPositive
                            value={relationInfo?.echeckOrderValueThreshold ?? ""}
                            change={(newValue) => handleChange("echeckOrderValueThreshold", newValue === "" ? null : newValue)}
                        />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("echeck_always_print_bulk_labels")}</Text>
                            <EMGeneralExplainerBox
                                title={t("echeck_always_print_bulk_labels")}
                                text={t("em_echeck_always_print_bulk_labels_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch
                            checked={relationInfo?.echeckAlwaysPrintBulkLabels}
                            onChange={(event) => handleChange('echeckAlwaysPrintBulkLabels', event.target.checked)}
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>

                {showTrackAndTraceMails &&
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("send_track_and_trace_email")}</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch 
                            checked={relationInfo?.sendTrackAndTraceEmail} 
                            onChange={(event) => handleChange('sendTrackAndTraceEmail', event.target.checked)} 
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>
                }
                {showTrackAndTraceMails &&
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:shippingLabelWidth,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("get_tracking_options_from_shop")}</Text>
                            <EMGeneralExplainerBox
                                title={t("get_tracking_options_from_shop")}
                                text={t("em_get_tracking_options_from_shop_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <InputDropdown
                            searchOptions={{
                                enabled: true,
                                placeholder: t("search")
                            }}
                            styles={{
                                minWidth:300
                            }}
                            name="trackWebshopCredentialsId"
                            displayName="name"
                            selected={credentialOptions?.findIndex(c => c.id === relationInfo?.trackWebshopCredentialsId) ?? -1}
                            options={credentialOptions ?? []}
                            noSelection={t("choose_option")} 
                            onChange={(selected) => handleChange('trackWebshopCredentialsId', credentialOptions[selected]?.id)}
                            closeOnSelection
                        />
                        </Box>
                    </Box>
                }
                    
                </Box>
            </Box>
        </Dropdown>
        <Dropdown title={t("orders")} subTitle={ showDropshipping ? t("sp_relation_orders_subtitle_with_dropshipping") : t("sp_relation_orders_subtitle")}>
            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                "@media screen and (max-width: 47.9375em)" : {
                    flexDirection:"column"
                }
            }}>
                {/* Two columns */}
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 1.5,
                        justifyContent:"flex-start",
                        flexDirection:"column"
                    }}
                >
                    {showDropshipping && (
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:304,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("manual_orders_dropship")}</Text>
                            <EMGeneralExplainerBox
                                title={t("em_manual_orders_dropship_title")}
                                text={t("em_manual_orders_dropship_text")}
                            />
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch 
                            checked={relationInfo?.manualOrdersDropship} 
                            onChange={(event) => handleChange('manualOrdersDropship', event.target.checked)} 
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>
                    )}
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:304,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("auto_split_manual_orders")}</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch 
                            checked={relationInfo?.autoSplitOrders} 
                            onChange={(event) => handleChange('autoSplitOrders', event.target.checked)} 
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                        }}
                    >
                        <Box 
                            sx={{
                                width:304,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text noBreak>{t("only_pick_on_workingdays")}</Text>
                        </Box>
                        <Box display="flex"
                            borderRadius="20px"
                            sx={{
                                flex:1,
                            }}
                        >
                        <ShSwitch 
                            checked={relationInfo?.onlyPickOnWorkingDays} 
                            onChange={(event) => handleChange('onlyPickOnWorkingDays', event.target.checked)} 
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Dropdown>
            <SpDesktopFooter>

                <GridActions
                    id={relationInfo?.id}
                    action={handleSaveClick}
                    isLoading={isLoading}
                    hasModifyPrivilege={hasModifyPrivilege}
                />
            </SpDesktopFooter>
            <MConfirmation
                ignoreCloseAfterConfirm={true}
                open={confirmModal.open}
                handleClose={handleConfirmClose}
                title={t("mc_relation_update_invoice_title")}
                subtitle={t("mc_relation_update_invoice_subtitle")}
                confirm={() => handleConfirmConfirm()}
            />
            {/* <Box
                sx={{
                    position:"absolute",
                    bottom:0,
                    right:0,
                    padding:3,
                    width:1,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    "@media screen and (min-width: 47.9376em) and (max-width: 63.9375em)" : {
                        padding:2,
                        paddingY:2.5,
                    }
                }}
            >
                <GridActions
                    id={relationInfo?.id}
                    action={handleSaveClick}
                />
            </Box> */}
        </Box>
    );
}

export default DetailsPanel;